import { logoutAndRedirectToLogin } from '../auth/logout';
import oktaAuth from '../auth/okta-auth';

/**
 * Called when authentication is required (e.g., session timeout).
 * Reuses the same logout + redirect logic as explicit logout
 * so the redirect path is consistent.
 */
const onAuthRequired = (): void => {
  logoutAndRedirectToLogin(oktaAuth);
};

export default onAuthRequired;